// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"232":"sira","841":"studio","860":"radio"}[chunkId] + "." + {"232":"6a314d9a","841":"189e7f27","860":"21594975"}[chunkId] + ".css";
};